// Lignée paternelle / maternelle d'une personne : ascendants par la ligne choisie + descendants par la même ligne.
export function lineage(persons, rootId, mode) {
  if (!rootId || mode === "full") return persons;
  const byId = Object.fromEntries(persons.map(p => [p.id, p]));
  const key = mode === "paternal" ? "father_id" : "mother_id";
  const keep = new Set();
  let cur = byId[rootId];
  const guard = new Set();
  while (cur && !guard.has(cur.id)) { guard.add(cur.id); keep.add(cur.id); cur = byId[cur[key]]; }
  const top = [...keep];
  const queue = [...top];
  while (queue.length) {
    const id = queue.shift();
    persons.filter(c => c[key] === id && !keep.has(c.id)).forEach(c => { keep.add(c.id); queue.push(c.id); });
  }
  [...keep].forEach(id => (byId[id]?.spouse_ids || []).forEach(s => byId[s] && keep.add(s)));
  return persons.filter(p => keep.has(p.id));
}
